export default {
    data () {
        return {
            swiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable :true,
                },
                navigation: {
                    nextEl: '.carousel-recommend-next',
                    prevEl: '.carousel-recommend-prev',
                }
            },
            swiperActivityOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable :true,
                },
                navigation: {
                    nextEl: '.carousel-next',
                    prevEl: '.carousel-prev',
                }
            }
        }
    },
}
